export default {
  SET_GRID_DATA_ACCKEY_EXCEPTION(state, params) {
    state.gridData = params;
  },

  SET_PROJECT_LIST_ACCKEY_EXCEPTION(state, params) {
    state.projectList = params;
  },

  SET_SEARCH_PARAM_ACCKEY_EXCEPTION(state, params) {
    state.searchParam = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/exception/accKeyExceptionMutation.js